import dmv from "./user"

export const DMVReducers = {
  dmv: dmv.reducer
}
